import "./svg-icon.less";

const fill = true;
const stroke = true;

const iconListData = {
  "align-center": {
    fill,
    viewBox: "0 0 14 14",
    icon: (
      <g fillRule="evenodd" clipRule="evenodd">
        <path d="M14 2H0V0H14V2Z" />
        <path d="M11 6H3V4H11V6Z" />
        <path d="M11 14H3V12H11V14Z" />
        <path d="M14 10H0V8H14V10Z" />
      </g>
    ),
  },
  "align-justify": {
    fill,
    viewBox: "0 0 14 14",
    icon: (
      <g fillRule="evenodd" clipRule="evenodd">
        <path d="M14 2H0V0H14V2Z" />
        <path d="M14 6H0V4H14V6Z" />
        <path d="M14 14H0V12H14V14Z" />
        <path d="M14 10H0V8H14V10Z" />
      </g>
    ),
  },
  "align-left": {
    fill,
    viewBox: "0 0 14 14",
    icon: (
      <g fillRule="evenodd" clipRule="evenodd">
        <path d="M14 2H0V0H14V2Z" />
        <path d="M10 6H0V4H10V6Z" />
        <path d="M10 14H0V12H10V14Z" />
        <path d="M14 10H0V8H14V10Z" />
      </g>
    ),
  },
  "align-right": {
    fill,
    viewBox: "0 0 14 14",
    icon: (
      <g fillRule="evenodd" clipRule="evenodd">
        <path d="M14 2H0V0H14V2Z" />
        <path d="M14 6H4V4H14V6Z" />
        <path d="M14 14H4V12H14V14Z" />
        <path d="M14 10H0V8H14V10Z" />
      </g>
    ),
  },
  "arrow-left": {
    fill,
    viewBox: "0 0 14 10",
    icon: (
      <g fillRule="evenodd" clipRule="evenodd">
        <path d="M4.15524 0.170617C4.35142 -0.0492498 4.67744 -0.0577365 4.88343 0.151661C5.08942 0.361058 5.09737 0.709044 4.90119 0.928911L1.61201 4.49447C1.35941 4.77757 1.35941 5.22243 1.61201 5.50553L4.90119 9.07109C5.09737 9.29096 5.08942 9.63894 4.88343 9.84834C4.67744 10.0577 4.35142 10.0493 4.15524 9.82938L0.189448 5.50553C-0.0631518 5.22243 -0.0631499 4.77757 0.18945 4.49447L4.15524 0.170617Z" />
        <path d="M14 5.01264C14 5.31627 13.7694 5.5624 13.4849 5.5624L1.50939 5.5624C1.22493 5.5624 0.994327 5.31627 0.994327 5.01264C0.994327 4.70902 1.22493 4.46288 1.50939 4.46288L13.4849 4.46288C13.7694 4.46288 14 4.70901 14 5.01264Z" />
      </g>
    ),
  },
  "arrow-right": {
    fill,
    viewBox: "0 0 14 10",
    icon: (
      <g fillRule="evenodd" clipRule="evenodd">
        <path d="M9.84476 9.82938C9.64858 10.0493 9.32256 10.0577 9.11657 9.84834C8.91058 9.63894 8.90263 9.29096 9.09881 9.07109L12.388 5.50553C12.6406 5.22243 12.6406 4.77757 12.388 4.49447L9.09881 0.928911C8.90263 0.709044 8.91058 0.361057 9.11657 0.15166C9.32256 -0.0577373 9.64858 -0.0492497 9.84476 0.170617L13.8106 4.49447C14.0632 4.77757 14.0631 5.22243 13.8105 5.50553L9.84476 9.82938Z" />
        <path d="M0 4.98736C0 4.68373 0.230603 4.4376 0.515066 4.4376H12.4906C12.7751 4.4376 13.0057 4.68373 13.0057 4.98736C13.0057 5.29099 12.7751 5.53712 12.4906 5.53712H0.515066C0.230603 5.53712 0 5.29099 0 4.98736Z" />
      </g>
    ),
  },
  bell: {
    fill,
    viewBox: "0 0 29 29",
    icon: (
      <>
        <path d="M23.993 12.2268C23.993 4.85599 20.0281 2.3487 16.3201 1.78984C16.3201 1.75208 16.3276 1.71432 16.3276 1.66901C16.3276 0.740104 15.5044 0 14.5 0C13.4956 0 12.7026 0.740104 12.7026 1.66901C12.7026 1.71432 12.7026 1.75208 12.7102 1.78984C8.99453 2.35625 5.00703 4.87109 5.00703 12.2419C5.00703 20.8362 2.86979 21.7576 0 24.1742H29C26.1453 21.75 23.993 20.8211 23.993 12.2268Z" />
        <path d="M14.5151 29C16.5391 29 18.2005 27.4971 18.4195 25.7526H10.6107C10.8221 27.4971 12.4911 29 14.5151 29Z" />
      </>
    ),
  },
  bold: {
    fill,
    viewBox: "0 0 10 13",
    icon: (
      <path d="M7.79883 6.30078C8.13086 6.48958 8.43034 6.73047 8.69727 7.02344C8.92513 7.27734 9.13021 7.59635 9.3125 7.98047C9.5013 8.36458 9.5957 8.83659 9.5957 9.39648C9.5957 9.87826 9.49479 10.3372 9.29297 10.7734C9.09766 11.2031 8.81771 11.584 8.45312 11.916C8.09505 12.2415 7.67188 12.5052 7.18359 12.707C6.70182 12.9023 6.17448 13 5.60156 13H0.503906V0.402344H5.50391C5.9987 0.402344 6.46419 0.496745 6.90039 0.685547C7.3431 0.867839 7.72721 1.11849 8.05273 1.4375C8.37826 1.75651 8.63216 2.1276 8.81445 2.55078C9.00326 2.96745 9.09766 3.41667 9.09766 3.89844C9.09766 4.29557 9.02604 4.64714 8.88281 4.95312C8.74609 5.2526 8.59961 5.5 8.44336 5.69531C8.25456 5.9362 8.03971 6.13802 7.79883 6.30078ZM2.39844 5.59766H5.50391C6.01172 5.59766 6.43815 5.42839 6.7832 5.08984C7.12826 4.7513 7.30078 4.35417 7.30078 3.89844C7.30078 3.44271 7.125 3.04557 6.77344 2.70703C6.42839 2.36849 6.00521 2.19922 5.50391 2.19922H2.39844V5.59766ZM5.60156 11.2031C5.89453 11.2031 6.17122 11.151 6.43164 11.0469C6.69206 10.9362 6.91341 10.793 7.0957 10.6172C7.28451 10.4349 7.43099 10.2233 7.53516 9.98242C7.64583 9.74154 7.70117 9.48112 7.70117 9.20117C7.70117 8.92122 7.64583 8.66081 7.53516 8.41992C7.43099 8.17904 7.28451 7.9707 7.0957 7.79492C6.91341 7.61263 6.69206 7.4694 6.43164 7.36523C6.17122 7.25456 5.89453 7.19922 5.60156 7.19922H2.39844V11.2031H5.60156Z" />
    ),
  },
  "bg-color": {
    fill,
    viewBox: "0 0 25 16",
    icon: (
      <>
        <path d="M2.08302 8L6.07266 11.8356C6.18665 11.9452 6.30064 12 6.47162 12C6.64261 12 6.7566 11.9452 6.87059 11.8356L10.8032 8.05479L11.6582 7.23288C11.8861 7.0137 11.8861 6.68493 11.6582 6.46575L6.58561 1.53425L5.16074 0.164384C4.93276 -0.0547945 4.5908 -0.0547945 4.36282 0.164384C4.13484 0.383562 4.13484 0.712329 4.36282 0.931507L5.38872 1.91781L1.00012 6.13699C0.772143 6.35616 0.772143 6.68493 1.00012 6.90411L2.08302 8ZM6.18665 2.68493L6.41463 2.9589L10.4043 6.79452L10.1763 7.06849H2.70997L2.14002 6.52055L6.18665 2.68493Z" />
        <path
          opacity="0.3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5 16H1V14H12.5V16Z"
        />
        <path
          stroke="currentColor"
          strokeWidth="0.2"
          d="M19.5205 9.87823L19.5205 9.87823L19.5214 9.87925C19.7876 10.1736 20.2124 10.1736 20.4786 9.87925L20.4786 9.87926L20.4795 9.87823L23.9382 5.94697C24.1472 5.71529 24.1544 5.33695 23.956 5.09506C23.7502 4.84424 23.4002 4.83333 23.1827 5.07379L23.1827 5.07378L23.1816 5.07503L20.3297 8.33533C20.1431 8.54108 19.8569 8.54108 19.6703 8.33534L16.8184 5.07503L16.8184 5.07502L16.8173 5.07379C16.5998 4.83333 16.2498 4.84424 16.044 5.09506C15.8456 5.33695 15.8528 5.71529 16.0618 5.94696L19.5205 9.87823Z"
        />
        <path d="M11.5 12C12.0667 12 12.5 11.4429 12.5 10.7143C12.5 10.1143 11.9 9.34286 11.7333 9.12857C11.6 8.95714 11.4 8.95714 11.2667 9.12857C11.1 9.34286 10.5 10.1143 10.5 10.7143C10.5 11.4429 10.9333 12 11.5 12Z" />
      </>
    ),
  },
  calendar: {
    fill,
    viewBox: "0 0 13 15",
    icon: (
      <>
        <path d="M11.9806 1.88817H10.0685V0.381897C10.0685 0.170707 9.89756 0 9.68612 0C9.47468 0 9.30376 0.170707 9.30376 0.381897V1.88817H7.00965V0.381897C7.00965 0.170707 6.83835 0 6.62729 0C6.41624 0 6.24494 0.170707 6.24494 0.381897V1.88817H3.95082V0.381897C3.95082 0.170707 3.77953 0 3.56847 0C3.35741 0 3.18612 0.170707 3.18612 0.381897V1.88817H1.01974C0.456529 1.88817 0 2.34378 0 2.90631V13.9815C0 14.544 0.456529 15 1.01974 15H11.9806C12.5439 15 13 14.544 13 13.9815V2.90631C13 2.34378 12.5439 1.88817 11.9806 1.88817ZM12.2353 13.9815C12.2353 14.122 12.121 14.2362 11.9806 14.2362H1.01974C0.87903 14.2362 0.764706 14.122 0.764706 13.9815V2.90631C0.764706 2.76616 0.87903 2.65197 1.01974 2.65197H3.18612V3.92496C3.18612 4.13615 3.35741 4.30686 3.56847 4.30686C3.77953 4.30686 3.95082 4.13615 3.95082 3.92496V2.65197H6.24494V3.92496C6.24494 4.13615 6.41624 4.30686 6.62729 4.30686C6.83835 4.30686 7.00965 4.13615 7.00965 3.92496V2.65197H9.30376V3.92496C9.30376 4.13615 9.47468 4.30686 9.68612 4.30686C9.89756 4.30686 10.0685 4.13615 10.0685 3.92496V2.65197H11.9806C12.121 2.65197 12.2353 2.76616 12.2353 2.90631V13.9815Z" />
        <path d="M5.80377 7H3.69341V8.23324H5.80377V7Z" />
        <path d="M9.30376 7H7.12197V8.23324H9.30376V7Z" />
        <path d="M5.80376 10H3.69341V11.2332H5.80376V10Z" />
        <path d="M9.30376 10H7.12197V11.2332H9.30376V10Z" />
      </>
    ),
  },
  chain: {
    fill,
    viewBox: "0 0 26 27",
    icon: (
      <path d="M13 0L0 8.11067V18.8893L13 27L26 18.8893V8.11067L13 0ZM14.2679 17.2994L11.3282 20.2747C10.6818 20.9289 9.83033 21.256 8.97887 21.256C8.12741 21.256 7.27596 20.9289 6.62959 20.2747L6.29398 19.935C5.00125 18.6266 5.00125 16.4942 6.29398 15.1795L9.92356 11.506C10.3648 11.0593 10.9117 10.7574 11.5084 10.6127C11.757 10.5561 12.0118 10.5184 12.2728 10.5184C12.8508 10.5184 13.404 10.6693 13.8887 10.9461C14.1498 11.0971 14.3984 11.2795 14.6159 11.506L14.9515 11.8456C15.1628 12.0595 15.3431 12.2985 15.4922 12.5627L14.4916 13.5755C14.386 13.5126 14.2927 13.4245 14.2306 13.305C14.1498 13.154 14.0441 13.0156 13.9198 12.8898L13.5842 12.5502C13.2362 12.1916 12.7638 11.9966 12.2728 11.9966C11.9932 11.9966 11.7259 12.0595 11.4835 12.179C11.2909 12.2734 11.1168 12.3929 10.9615 12.5502L9.55687 13.9718L7.33189 16.2237C6.60473 16.9597 6.60473 18.1486 7.33189 18.8846L7.6675 19.2242C8.39466 19.9602 9.5693 19.9602 10.2965 19.2242L12.4406 17.0541C12.8881 17.2113 13.3667 17.2994 13.8577 17.2994C14.0006 17.2994 14.1436 17.2931 14.2803 17.2805C14.2741 17.2931 14.2741 17.2994 14.2679 17.2994ZM19.706 11.8016L16.2132 15.3368C15.6662 15.8903 14.964 16.2237 14.2057 16.3055H14.1933C14.0814 16.3181 13.9758 16.3244 13.8639 16.3244C13.7645 16.3244 13.665 16.3181 13.5656 16.3118C13.5158 16.3055 13.4661 16.2992 13.4164 16.2929C13.3729 16.2866 13.3294 16.2803 13.2859 16.2741C13.2175 16.2615 13.1429 16.2426 13.0746 16.23C13.0559 16.2237 13.0373 16.2174 13.0186 16.2174C12.9441 16.1986 12.8633 16.1734 12.7887 16.1482C12.3163 15.9847 11.8875 15.7142 11.527 15.3494L11.1914 15.0097C10.9801 14.7958 10.7999 14.5505 10.6507 14.2926L11.6513 13.2798C11.757 13.3427 11.8502 13.4308 11.9186 13.5503C11.9994 13.7013 12.105 13.8397 12.2293 13.9655L12.5649 14.3052C12.913 14.6574 13.3853 14.8587 13.8763 14.8587C14.0938 14.8587 14.3052 14.821 14.504 14.7455C14.7402 14.6574 14.9577 14.5253 15.1442 14.3492C15.1628 14.3366 15.1753 14.3177 15.1939 14.3052L18.6868 10.77C19.041 10.4177 19.2337 9.93965 19.2337 9.44271C19.2337 8.93948 19.041 8.4677 18.6868 8.11544L18.3511 7.77576C17.624 7.03979 16.4493 7.03979 15.7222 7.77576L13.6961 9.78868C13.2424 9.62513 12.7576 9.54336 12.2728 9.54336C12.1361 9.54336 11.9932 9.54965 11.8502 9.56852C11.8564 9.56223 11.8564 9.55594 11.8626 9.54965L14.6718 6.7064C15.9646 5.398 18.0715 5.398 19.3704 6.7064L19.706 7.04608C20.3337 7.68141 20.6756 8.52432 20.6756 9.42384C20.6756 10.3171 20.3337 11.1663 19.706 11.8016Z" />
    ),
  },
  "chain-o": {
    fill,
    stroke,
    viewBox: "0 0 12 12",
    icon: (
      <path
        strokeWidth="0.1"
        d="M6.63228 4.46838L6.66546 4.48741C6.83689 4.5857 6.99972 4.70561 7.14704 4.85295C7.14704 4.85295 7.14704 4.85295 7.14704 4.85295M6.63228 4.46838L7.14704 4.85295M6.63228 4.46838L6.60523 4.49543L6.24771 4.85295M6.63228 4.46838L6.24771 4.85295M7.14704 4.85295C8.0443 5.75019 8.09648 7.28879 7.14704 8.23823L5.03637 10.3489C4.10153 11.2837 2.58594 11.2837 1.6511 10.3489C0.7163 9.41406 0.7163 7.89846 1.6511 6.96362L1.67977 6.99228L1.6511 6.96362L3.76175 4.85293L3.76181 4.85287C3.76733 4.84737 3.77304 4.84316 3.77596 4.84101L3.77641 4.84067C3.77955 4.83835 3.78012 4.83786 3.78014 4.83784L3.88557 4.73424L3.86467 4.88059C3.77382 5.51673 3.89538 5.94699 3.9686 6.20618C3.98733 6.27247 4.0029 6.32758 4.01094 6.37207L4.01559 6.39782L3.99709 6.41632L2.55047 7.86294C2.11298 8.30042 2.11298 9.01203 2.55047 9.44952C2.98795 9.887 3.69956 9.887 4.13704 9.44952L6.24771 7.33885C6.68834 6.89822 6.66961 6.17418 6.24771 5.75227C6.20418 5.70874 6.15655 5.67112 6.10639 5.63559L6.08584 5.62103L6.0853 5.59585C6.08462 5.56396 6.08132 5.52809 6.07775 5.48924C6.06108 5.3081 6.03845 5.06218 6.24771 4.85295M7.14704 4.85295L6.24771 4.85295M6.24771 4.85295C6.24771 4.85295 6.24771 4.85295 6.24771 4.85295M6.24771 4.85295L6.24771 4.85295M5.48637 7.36081L5.51954 7.37983L5.54659 7.35279L5.90411 6.99527L5.90411 6.99526C6.11333 6.786 6.0907 6.54008 6.07403 6.35894C6.07046 6.32009 6.06715 6.28421 6.06647 6.25232L6.06594 6.22715L6.0454 6.2126C5.99527 6.17706 5.94764 6.13943 5.90411 6.0959L5.87147 6.12854L5.9041 6.0959C5.4822 5.67404 5.46347 4.94996 5.90411 4.50933L7.86294 2.5505C8.30042 2.11301 9.01203 2.11301 9.44952 2.5505C9.887 2.98798 9.887 3.69959 9.44952 4.13707L8.15473 5.43186L8.13623 5.45036L8.14088 5.47611C8.14892 5.5206 8.16449 5.5757 8.18321 5.64199C8.25643 5.90117 8.37798 6.33144 8.28715 6.96759L8.26625 7.11393L8.37167 7.01034C8.37167 7.01034 8.37219 7.00988 8.37537 7.00754L8.37581 7.00721C8.37872 7.00506 8.38444 7.00085 8.38997 6.99535L8.39003 6.99529L10.3489 5.03642C11.2837 4.10158 11.2837 2.58597 10.3489 1.65113C9.41406 0.716293 7.89845 0.716293 6.96361 1.65111L6.99897 1.68647L6.96361 1.65111L5.00474 3.60998C4.03724 4.57753 4.12732 6.1178 5.00474 6.99527C5.15207 7.1426 5.31488 7.26251 5.48637 7.36081Z"
      />
    ),
  },
  "check-list": {
    fill,
    viewBox: "0 0 15 16",
    icon: (
      <g fillRule="evenodd" clipRule="evenodd">
        <path d="M15 3H6V1H15V3Z" />
        <path d="M15 15H6V13H15V15Z" />
        <path d="M15 9H6V7H15V9Z" />
        <path d="M5.45952 0.959522L2.4999 3.91914L0.540283 1.95952L1.45952 1.04028L2.4999 2.08066L4.54028 0.0402832L5.45952 0.959522ZM5.45952 6.95952L2.4999 9.91914L0.540283 7.95952L1.45952 7.04028L2.4999 8.08066L4.54028 6.04028L5.45952 6.95952ZM5.45952 12.9595L2.4999 15.9191L0.540283 13.9595L1.45952 13.0403L2.4999 14.0807L4.54028 12.0403L5.45952 12.9595Z" />
      </g>
    ),
  },
  clear: {
    fill,
    stroke,
    viewBox: "0 0 17 14",
    icon: (
      <>
        <path
          strokeWidth="0.2"
          d="M11.2778 0.929289L11.2071 0.858579L11.1364 0.929289L0.929289 11.1364L0.855457 11.2102L0.932408 11.2808L3.43241 13.5737L3.46109 13.6H3.5H9H9.04094L9.07012 13.5713L16.4843 6.2784L16.5562 6.20769L16.4849 6.1364L11.2778 0.929289ZM8.54492 12.4H3.95136L2.56107 11.2017L11.2071 2.55564L14.8579 6.20643L8.54492 12.4Z"
        />
        <path
          strokeWidth="0.2"
          d="M13.707 13.6H13.807V13.5V12.5V12.4H13.707H11.9999H11.8999V12.5V13.5V13.6H11.9999H13.707ZM16.707 13.6H16.807V13.5V12.5V12.4H16.707H15H14.9V12.5V13.5V13.6H15H16.707Z"
        />
      </>
    ),
  },
  clock: {
    stroke,
    viewBox: "0 0 14 14",
    icon: (
      <>
        <circle cx="7" cy="7" r="6.5" />
        <path
          fill="currentColor"
          stroke="none"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.5 2C6.5 1.72386 6.72386 1.5 7 1.5C7.27614 1.5 7.5 1.72386 7.5 2V6C7.5 6.55228 7.94772 7 8.5 7H10C10.2761 7 10.5 7.22386 10.5 7.5C10.5 7.77614 10.2761 8 10 8H7.5C6.94772 8 6.5 7.55228 6.5 7V2Z"
        />
      </>
    ),
  },
  upload: {
    stroke,
    viewBox: "0 0 33 26",
    icon: (
      <path
        d="M26.7708 9.97437C26.3598 4.74549 21.9732 0.616364 16.6404 0.616364C12.0789 0.616364 8.16314 3.57913 6.89968 7.90021C3.29558 9.15125 0.833008 12.5657 0.833008 16.4238C0.833008 21.4043 4.88536 25.4566 9.86583 25.4566H24.5442C28.9025 25.4566 32.4479 21.9112 32.4479 17.5529C32.4479 13.9974 30.1106 10.9454 26.7708 9.97437ZM22.2001 13.4689C22.0251 13.8901 21.613 14.1656 21.1569 14.1656H18.8987V18.682C18.8987 19.9285 17.887 20.9402 16.6404 20.9402C15.3939 20.9402 14.3822 19.9285 14.3822 18.682V14.1656H12.124C11.6679 14.1656 11.2558 13.8901 11.0807 13.4689C10.9057 13.0467 11.0028 12.5611 11.3258 12.2382L15.8422 7.72181C16.0623 7.50163 16.3514 7.39098 16.6404 7.39098C16.9295 7.39098 17.2185 7.50163 17.4387 7.72181L21.9551 12.2382C22.2781 12.5611 22.3752 13.0467 22.2001 13.4689Z"
        fill="currentColor"
      />
    ),
  },
  lock: {
    fill,
    viewBox: "0 0 8 12",
    icon: (
      <>
        <path
          d="M7.45455 4.16699H0.545455C0.244091 4.16699 0 4.42803 0 4.75033V9.25033C0 9.57262 0.244091 9.83366 0.545455 9.83366H7.45455C7.75591 9.83366 8 9.57262 8 9.25033V4.75033C8 4.42803 7.75591 4.16699 7.45455 4.16699ZM4 7.08366C3.69864 7.08366 3.45455 6.82233 3.45455 6.50033C3.45455 6.17803 3.69864 5.91699 4 5.91699C4.30136 5.91699 4.54545 6.17803 4.54545 6.50033C4.54545 6.82233 4.30136 7.08366 4 7.08366ZM5.63636 7.08366C5.335 7.08366 5.09091 6.82233 5.09091 6.50033C5.09091 6.17803 5.335 5.91699 5.63636 5.91699C5.93773 5.91699 6.18182 6.17803 6.18182 6.50033C6.18182 6.82233 5.93773 7.08366 5.63636 7.08366ZM2.36364 7.08366C2.06227 7.08366 1.81818 6.82233 1.81818 6.50033C1.81818 6.17803 2.06227 5.91699 2.36364 5.91699C2.665 5.91699 2.90909 6.17803 2.90909 6.50033C2.90909 6.82233 2.665 7.08366 2.36364 7.08366Z"
          fill="currentColor"
        />
        <mask id="path-2-inside-1_4935_22832" fill="white">
          <path d="M5.99902 5.22149H2.04297V2.75C2.04297 1.78342 3.09531 1 3.99913 1C4.90295 1 5.99902 1.78342 5.99902 2.75V5.22149Z" />
        </mask>
        <path
          d="M5.99902 5.22149V6.22149C6.55131 6.22149 6.99902 5.77378 6.99902 5.22149H5.99902ZM2.04297 5.22149H1.04297C1.04297 5.77378 1.49068 6.22149 2.04297 6.22149V5.22149ZM5.99902 4.22149H2.04297V6.22149H5.99902V4.22149ZM3.04297 5.22149V2.75H1.04297V5.22149H3.04297ZM3.04297 2.75C3.04297 2.64244 3.10574 2.46313 3.32624 2.27745C3.54875 2.09008 3.81566 2 3.99913 2V0C3.27877 0 2.56761 0.301626 2.03799 0.747613C1.50636 1.19529 1.04297 1.89098 1.04297 2.75H3.04297ZM3.99913 2C4.18627 2 4.46826 2.09296 4.70472 2.28645C4.94101 2.4798 4.99902 2.65797 4.99902 2.75H6.99902C6.99902 1.87545 6.509 1.17862 5.9713 0.738617C5.43376 0.298752 4.71581 0 3.99913 0V2ZM4.99902 2.75V5.22149H6.99902V2.75H4.99902Z"
          fill="currentColor"
          mask="url(#path-2-inside-1_4935_22832)"
        />
      </>
    ),
  },
  close: {
    stroke,
    viewBox: "0 0 10 10",
    icon: <path strokeWidth="1.2" d="M1 1L5 5M9 9L5 5M5 5L1 9L9 1" />,
  },
  checkmark: {
    stroke,
    viewBox: "0 0 11 8",
    icon: <path d="M1 3L4.5 6.5L10 1" strokeWidth="1.2" />,
  },
  copy: {
    stroke,
    viewBox: "0 0 13 15",
    icon: (
      <g>
        <path d="M0.5 1C0.5 0.723858 0.723858 0.5 1 0.5H7.25032C7.52646 0.5 7.75032 0.723857 7.75032 1V9.3129C7.75032 9.58904 7.52646 9.8129 7.25032 9.8129H1C0.723858 9.8129 0.5 9.58904 0.5 9.3129V1Z" />
        <rect
          fill="#FFFBF6"
          x="3.25"
          y="3.24976"
          width="7.25032"
          height="9.3129"
          rx="0.5"
        />
        <rect
          stroke="#FFFBF6"
          x="2.105"
          y="2.10476"
          width="9.54032"
          height="11.6029"
          rx="1.645"
          strokeWidth="1.29"
        />
      </g>
    ),
  },
  down: {
    stroke,
    viewBox: "0 0 9 6",
    icon: <path d="M1 1L4.5 5L8 1" strokeWidth="1.3" />,
  },
  "down-2": {
    fill,
    stroke,
    viewBox: "0.75 0 8.5 7",
    icon: (
      <path
        strokeWidth="0.2"
        d="M4.5205 5.87823L4.52049 5.87824L4.52141 5.87925C4.78759 6.17358 5.21241 6.17358 5.47859 5.87925L5.4786 5.87926L5.4795 5.87823L8.93815 1.94697C9.14716 1.71529 9.15441 1.33695 8.95599 1.09506C8.75025 0.844238 8.40017 0.833326 8.1827 1.07379L8.18269 1.07378L8.1816 1.07503L5.32972 4.33534C5.14311 4.54108 4.8569 4.54108 4.67028 4.33534L1.8184 1.07503L1.81841 1.07502L1.8173 1.07379C1.59983 0.833326 1.24975 0.844238 1.04401 1.09506C0.845596 1.33695 0.852843 1.71529 1.06184 1.94696L4.5205 5.87823Z"
      />
    ),
  },
  "down-circle": {
    stroke,
    viewBox: "0 0 13 13",
    icon: (
      <g>
        <circle cx="6.5" cy="6.5" r="6" />
        <path
          fill="currentColor"
          strokeWidth="0.3"
          d="M4.26464 4.90479L4.26466 4.90477L4.26307 4.9029C4.17029 4.79347 4.04266 4.73335 3.90859 4.7374C3.77476 4.74144 3.65079 4.8089 3.5634 4.92255C3.39554 5.14082 3.40093 5.47736 3.57857 5.68773L6.17227 8.83239L6.17226 8.8324L6.17358 8.83395C6.28434 8.96459 6.43408 9.03721 6.59131 9.03721C6.74854 9.03721 6.89828 8.9646 7.00904 8.83395L7.00905 8.83396L7.01034 8.83239L9.60406 5.68771C9.78168 5.47733 9.78707 5.14082 9.61922 4.92255C9.53182 4.8089 9.40785 4.74144 9.27402 4.7374C9.13996 4.73335 9.01232 4.79347 8.91955 4.9029L8.91953 4.90289L8.91798 4.90479L6.77949 7.51252C6.72056 7.58159 6.65222 7.60892 6.59131 7.60892C6.5304 7.60892 6.46206 7.58159 6.40313 7.51252L4.26464 4.90479Z"
        />
      </g>
    ),
  },
  download: {
    fill,
    viewBox: "0 0 9 12",
    icon: (
      <>
        <path
          d="M7.5 8.5V10.5H1V8.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.32296 5.84476C1.10309 5.64858 1.09461 5.32256 1.304 5.11657C1.5134 4.91058 1.86139 4.90262 2.08125 5.09881L3.64682 6.38799C3.92991 6.64059 4.37478 6.64059 4.65787 6.38799L6.22343 5.09881C6.4433 4.90263 6.79129 4.91058 7.00068 5.11657C7.21008 5.32256 7.20159 5.64858 6.98173 5.84476L4.65787 7.81055C4.37478 8.06315 3.92991 8.06315 3.64681 7.81055L1.32296 5.84476Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.16498 -1.30582e-07C4.46861 -1.1731e-07 4.71475 0.230603 4.71475 0.515066L4.71475 6.49061C4.71475 6.77507 4.46861 7.00567 4.16498 7.00567C3.86136 7.00567 3.61522 6.77507 3.61522 6.49061L3.61522 0.515066C3.61522 0.230603 3.86136 -1.43854e-07 4.16498 -1.30582e-07Z"
        />
      </>
    ),
  },
  edit: {
    fill,
    viewBox: "0 0 9 9",
    icon: (
      <path d="M3.16787 7.87426L1.12604 5.83291L6.06456 0.895543L8.10639 2.9369L3.16787 7.87426ZM0.935181 6.19249L2.8082 8.06507L2.2316e-05 9.00001L0.935181 6.19249ZM8.7344 2.31173L8.38025 2.6658L6.33572 0.621749L6.68987 0.267676C7.04662 -0.0892069 7.62514 -0.0892069 7.98189 0.267676L8.7344 1.02001C9.08856 1.37787 9.08856 1.95398 8.7344 2.31173Z" />
    ),
  },
  facebook: {
    fill,
    viewBox: "4 4 22 22",
    icon: (
      <path d="M24,4H6C4.895,4,4,4.895,4,6v18c0,1.105,0.895,2,2,2h10v-9h-3v-3h3v-1.611C16,9.339,17.486,8,20.021,8 c1.214,0,1.856,0.09,2.16,0.131V11h-1.729C19.376,11,19,11.568,19,12.718V14h3.154l-0.428,3H19v9h5c1.105,0,2-0.895,2-2V6 C26,4.895,25.104,4,24,4z" />
    ),
  },
  "facebook-outlined": {
    fill,
    viewBox: "0 0 6 12",
    icon: (
      <path d="M3.85714 12V6.66667H5.57143L6 4.44444H3.85714V3.55556C3.85714 2.66667 4.28657 2.22222 5.14286 2.22222H6V0C5.57143 0 5.04 0 4.28571 0C2.71071 0 1.71429 1.28044 1.71429 3.11111V4.44444H0V6.66667H1.71429V12H3.85714Z" />
    ),
  },
  google: {
    fill,
    viewBox: "0 0 11 12",
    icon: (
      <path d="M5.60074 5.21282C5.59832 5.8378 5.60074 6.46275 5.6032 7.0877C6.57487 7.12185 7.54894 7.10607 8.52062 7.12185C8.09203 9.44578 5.16 10.1994 3.60875 8.68165C2.01365 7.35031 2.08914 4.43032 3.74755 3.19352C4.90673 2.19567 6.55538 2.4425 7.71453 3.30643C8.16994 2.85216 8.59608 2.36635 9.00763 1.86218C8.04329 1.0324 6.85978 0.441567 5.60074 0.504606C2.97314 0.410065 0.557377 2.89154 0.513555 5.7249C0.345506 8.04092 1.75795 10.3123 3.75243 11.1316C5.73957 11.9561 8.28683 11.3942 9.5556 9.46941C10.3933 8.25362 10.5735 6.6886 10.4761 5.21808C8.84935 5.20494 7.22506 5.20756 5.60074 5.21282Z" />
    ),
  },
  folder: {
    fill,
    stroke,
    viewBox: "0 0 15 12",
    icon: (
      <path
        strokeWidth="0.15"
        strokeMiterlimit="10"
        strokeLinecap="round"
        d="M1.0425 9.3347L1.08133 9.22805L1.04795 9.10051L1.0425 9.3347ZM1.0425 9.3347L1.03705 9.56889L1.00633 9.65329V9.43405L1.0425 9.3347ZM1.08519 10.8276L3.16289 5.10157L3.16739 5.08918V5.07599V5.05437C3.16739 4.96762 3.24032 4.8938 3.33404 4.8938H13.7751C13.8591 4.8938 13.9266 4.95331 13.9395 5.02809L11.9759 10.6555C11.9648 10.6774 11.9563 10.7008 11.9507 10.7254L11.9506 10.7254L11.95 10.7288C11.9475 10.7405 11.9456 10.7525 11.9445 10.7647C11.9435 10.7757 11.943 10.7867 11.9431 10.7976M1.08519 10.8276L11.9431 10.7976M1.08519 10.8276C1.10141 10.8987 1.16692 10.9539 1.24797 10.9539L11.7766 10.9538C11.8687 10.9538 11.9408 10.8824 11.9431 10.7976M1.08519 10.8276L11.9431 10.7976M12.1134 10.7166C12.1414 10.6671 12.1957 10.6327 12.2599 10.6327C12.3537 10.6327 12.4265 10.7064 12.4265 10.7933C12.4265 10.7993 12.4264 10.8054 12.4262 10.8114L12.4258 10.8113L12.4238 10.8222C12.4075 10.908 12.3215 10.9678 12.2292 10.9511C12.1479 10.9364 12.0935 10.8684 12.0932 10.7938L12.1134 10.7166ZM12.1134 10.7166L12.0951 10.7693C12.0946 10.7725 12.0942 10.7756 12.0939 10.7787M12.1134 10.7166L12.0939 10.7787M12.0939 10.7787C12.0934 10.7835 12.0932 10.7884 12.0932 10.7933L12.0939 10.7787ZM1.0425 9.3347L1.04795 9.10051M1.08133 7.66522L1.23526 1.04658M4.84687 1.5093L4.86272 1.51724L4.88045 1.51725L11.4868 1.5183L11.487 1.67886V1.67888V1.67896L11.487 1.83943L4.87269 1.83837H4.87268C4.80925 1.83837 4.76637 1.83771 4.71526 1.81586C4.66286 1.79346 4.5951 1.74539 4.49692 1.6351C4.41158 1.53923 4.3318 1.41542 4.26037 1.30428L4.25198 1.29123C4.1744 1.17059 4.10558 1.06491 4.03623 0.988385C3.98168 0.928193 3.9474 0.909232 3.93017 0.901987L3.91623 0.896123H3.9011H1.24797C1.24489 0.896123 1.24182 0.896167 1.23876 0.896253L1.24623 0.575003C1.24681 0.575002 1.24739 0.575001 1.24797 0.575001H2.068L4.28805 0.778052C4.37727 0.87671 4.45943 1.00414 4.5323 1.11746L4.5353 1.12213L4.59839 1.08157L4.53531 1.12213C4.6132 1.24326 4.68142 1.34914 4.7499 1.42606C4.79903 1.48125 4.83054 1.50112 4.84687 1.5093ZM12.3619 2.15C12.3619 1.71661 12.0015 1.36833 11.5618 1.36832H11.5617H11.4866L10.7403 1.36819L4.49661 0.797127C4.46528 0.754995 4.43245 0.714013 4.39842 0.676461C4.30477 0.573127 4.14014 0.425001 3.90609 0.425001H1.24797C0.808132 0.425001 0.448034 0.773315 0.448034 1.20668V10.7868C0.447904 10.7923 0.447927 10.7978 0.448098 10.8033C0.453597 11.232 0.811527 11.575 1.24797 11.575L11.7766 11.5749C12.2 11.5749 12.5495 11.2522 12.575 10.8415L14.5708 5.10062L14.575 5.08866V5.07599V5.06443C14.6088 4.93741 14.6042 4.82205 14.5686 4.71922C14.5323 4.61431 14.4653 4.52742 14.3835 4.45637C14.2215 4.31566 13.9935 4.23041 13.792 4.18379L13.7833 4.18178L13.7744 4.18186L12.3619 4.19415V2.15ZM12.2119 2.15V4.19545L11.8786 4.19835L11.8786 2.15C11.8786 2.00263 11.7745 1.88121 11.637 1.84827L11.637 1.67893V1.6789V1.67888V1.67879V1.67868L11.6369 1.52249C11.9618 1.55879 12.2119 1.82756 12.2119 2.15ZM11.8999 4.34817L12.1921 4.34563C12.1643 4.39558 12.1098 4.43036 12.0453 4.43036C11.9819 4.43036 11.9281 4.39676 11.8999 4.34817ZM11.7287 2.15L11.7286 4.19966L3.33404 4.27268V4.34768L3.33338 4.27269L3.33371 4.27268C2.90709 4.27285 2.55568 4.6006 2.53505 5.01587L1.08133 9.00882V7.66522L1.23526 1.04658C1.23945 1.04628 1.24369 1.04612 1.24797 1.04612H3.88025C3.88916 1.05294 3.90403 1.06589 3.92508 1.08911C3.98445 1.15462 4.04637 1.24882 4.12582 1.37237L4.1889 1.3318L4.12582 1.37237L4.13419 1.38538L4.19728 1.34483L4.13419 1.38538L4.13576 1.38784C4.20548 1.49631 4.291 1.62938 4.38488 1.73484C4.49002 1.85294 4.57513 1.91908 4.65629 1.95378C4.73725 1.98839 4.80751 1.98838 4.8693 1.98837L4.87267 1.98837H4.87268L11.4869 1.98944H11.5619C11.6557 1.98944 11.7287 2.06328 11.7287 2.15ZM1.24797 11.425C0.999017 11.425 0.784048 11.2893 0.674786 11.0911C0.685394 11.0942 0.696259 11.0967 0.707356 11.0987C0.822118 11.1195 0.935127 11.0765 1.00642 10.9941C1.06483 11.0615 1.15189 11.1039 1.24797 11.1039L11.7766 11.1038C11.8727 11.1038 11.9598 11.0614 12.0182 10.9939C12.064 11.047 12.128 11.0852 12.2025 11.0987C12.2531 11.1078 12.3033 11.1046 12.3497 11.0911C12.2405 11.2892 12.0255 11.4249 11.7766 11.4249L1.24797 11.425ZM3.87017 1.03937C3.87017 1.03935 3.87051 1.0395 3.8712 1.0399L3.87017 1.03937Z"
      />
    ),
  },
  help: {
    fill,
    viewBox: "0 0 23 23",
    icon: (
      <>
        <path d="M20.2071 3.94286L15.525 8.625C16.1 9.44643 16.4286 10.4321 16.4286 11.5C16.4286 12.5679 16.1 13.5536 15.525 14.375L20.2071 19.0571C21.9321 17.0036 23 14.375 23 11.5C23 8.625 21.9321 5.99643 20.2071 3.94286Z" />
        <path d="M11.5 6.57143C12.5679 6.57143 13.5536 6.9 14.375 7.475L19.0571 2.79286C17.0036 1.06786 14.375 0 11.5 0C8.625 0 5.99643 1.06786 3.94286 2.79286L8.625 7.475C9.44643 6.9 10.4321 6.57143 11.5 6.57143Z" />
        <path d="M6.57143 11.5C6.57143 10.4321 6.9 9.44643 7.475 8.625L2.79286 3.94286C1.06786 5.99643 0 8.625 0 11.5C0 14.375 1.06786 17.0036 2.79286 19.0571L7.475 14.375C6.9 13.5536 6.57143 12.5679 6.57143 11.5Z" />
        <path d="M11.5 16.4286C10.4321 16.4286 9.44643 16.1 8.625 15.525L3.94286 20.2071C5.99643 21.9321 8.625 23 11.5 23C14.375 23 17.0036 21.9321 19.0571 20.2071L14.375 15.525C13.5536 16.1 12.5679 16.4286 11.5 16.4286Z" />
      </>
    ),
  },
  image: {
    fill,
    viewBox: "0 0 19 16",
    icon: (
      <>
        <path d="M13.5 7C14.5647 7 15.4286 6.10417 15.4286 5C15.4286 3.89583 14.5647 3 13.5 3C12.4353 3 11.5714 3.89583 11.5714 5C11.5714 6.10417 12.4353 7 13.5 7Z" />
        <path d="M17.875 0H1.125C0.498214 0 0 0.529167 0 1.17917V14.8208C0 15.4708 0.498214 16 1.125 16H17.875C18.5018 16 19 15.4708 19 14.8208V1.17917C19 0.529167 18.5018 0 17.875 0ZM13.5 11.6667C13.3795 11.5208 13.1946 11.4083 12.9857 11.4083C12.7808 11.4083 12.6362 11.5083 12.4714 11.6458L11.7201 12.3042C11.5634 12.4208 11.4388 12.5 11.258 12.5C11.0853 12.5 9.92857 12.4333 9.81607 12.3292C9.77589 12.2917 9.70357 12.2208 9.6433 12.1583L7.4817 9.73333C7.32098 9.54167 7.07991 9.42083 6.81071 9.42083C6.54152 9.42083 6.29241 9.55833 6.13571 9.74583L1.51205 14.1917V2C1.55223 1.71667 1.76518 1.5125 2.03839 1.5125H17C17.2772 1.5125 17.5022 1.725 17.5183 2.0125L17.5304 14.1917L13.5 11.6667Z" />
      </>
    ),
  },
  italic: {
    fill,
    viewBox: "0 0 9 13",
    icon: (
      <>
        <path d="M4.39844 13H2.50391L4.7207 0.402344H6.61523L4.39844 13Z" />
        <path d="M3 10.5L0.5 13H6.5L4.5 10.5H3Z" />
        <path d="M4.5 2.5L3 4.76995e-08L9 0L6 2.5L4.5 2.5Z" />
      </>
    ),
  },
  link: {
    stroke,
    viewBox: "0 0 20 10",
    icon: (
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7.26087 9H4.91304C4.39918 9 3.89034 8.89654 3.41559 8.69552C2.94083 8.4945 2.50946 8.19986 2.1461 7.82843C1.41227 7.07828 1 6.06087 1 5C1 3.93913 1.41227 2.92172 2.1461 2.17157C2.87994 1.42143 3.87524 1 4.91304 1H7.26087M6.47826 5L14 5M12.7391 1L15.087 1C15.6008 1 16.1097 1.10346 16.5844 1.30448C17.0592 1.5055 17.4905 1.80014 17.8539 2.17157C18.5877 2.92172 19 3.93913 19 5C19 6.06087 18.5877 7.07828 17.8539 7.82843C17.1201 8.57857 16.1248 9 15.087 9L12.7391 9"
      />
    ),
  },
  loading: {
    fill,
    viewBox: "0 0 36 36",
    className: "loading-icon",
    icon: (
      <>
        <path d="M17.498 0C16.9318 0 16.4727 0.459101 16.4727 1.02539V7.61523C16.4727 8.18152 16.9318 8.64062 17.498 8.64062C18.0643 8.64062 18.5234 8.18152 18.5234 7.61523V1.02539C18.5234 0.459101 18.0643 0 17.498 0Z" />
        <path d="M26.2472 2.34477C25.7567 2.06149 25.1296 2.22959 24.8465 2.72007L21.5517 8.42691C21.2684 8.91732 21.4365 9.54445 21.9269 9.82759C22.0884 9.92084 22.2647 9.96513 22.4387 9.96513C22.7931 9.96513 23.1377 9.78124 23.3276 9.4523L26.6225 3.74546C26.9056 3.25505 26.7376 2.62792 26.2472 2.34477Z" />
        <path d="M32.6517 8.75016C32.3685 8.25968 31.7415 8.09172 31.251 8.37486L25.5441 11.6698C25.0537 11.9529 24.8856 12.58 25.1688 13.0704C25.3587 13.3994 25.7034 13.5833 26.0577 13.5833C26.2316 13.5833 26.408 13.539 26.5695 13.4458L32.2764 10.1508C32.7668 9.8677 32.9348 9.24057 32.6517 8.75016Z" />
        <path d="M33.9745 16.4747H27.3848C26.8185 16.4747 26.3594 16.9338 26.3594 17.5001C26.3594 18.0664 26.8185 18.5255 27.3848 18.5255H33.9745C34.5408 18.5255 34.9999 18.0664 34.9999 17.5001C34.9999 16.9338 34.5408 16.4747 33.9745 16.4747Z" />
        <path d="M32.2803 24.8493L26.5734 21.5544C26.0828 21.2713 25.4558 21.4393 25.1727 21.9298C24.8896 22.4203 25.0576 23.0474 25.548 23.3305L31.2549 26.6253C31.4164 26.7185 31.5927 26.7628 31.7666 26.7628C32.121 26.7628 32.4658 26.579 32.6556 26.25C32.9387 25.7595 32.7707 25.1323 32.2803 24.8493Z" />
        <path d="M26.6224 31.2546L23.3276 25.5478C23.0444 25.0573 22.4173 24.8893 21.9269 25.1725C21.4365 25.4556 21.2685 26.0828 21.5516 26.5732L24.8465 32.28C25.0364 32.609 25.381 32.7929 25.7354 32.7929C25.9094 32.7929 26.0857 32.7486 26.2471 32.6553C26.7376 32.3722 26.9056 31.745 26.6224 31.2546Z" />
        <path d="M17.498 26.3595C16.9318 26.3595 16.4727 26.8186 16.4727 27.3849V33.9747C16.4727 34.5409 16.9318 35 17.498 35C18.0643 35 18.5234 34.5409 18.5234 33.9747V27.3849C18.5234 26.8185 18.0643 26.3595 17.498 26.3595Z" />
        <path d="M13.0714 25.1725C12.581 24.8893 11.9538 25.0573 11.6707 25.5478L8.37583 31.2548C8.09268 31.7452 8.26071 32.3723 8.75112 32.6555C8.91258 32.7487 9.08888 32.793 9.26286 32.793C9.61723 32.793 9.96197 32.6091 10.1518 32.2802L13.4467 26.5732C13.7299 26.0828 13.5618 25.4557 13.0714 25.1725Z" />
        <path d="M9.8276 21.9298C9.54446 21.4393 8.91747 21.2712 8.42692 21.5545L2.71987 24.8494C2.22946 25.1325 2.06143 25.7597 2.34458 26.2501C2.53448 26.5791 2.87915 26.7629 3.23352 26.7629C3.4075 26.7629 3.58379 26.7186 3.74526 26.6254L9.45231 23.3304C9.94272 23.0473 10.1107 22.4202 9.8276 21.9298Z" />
        <path d="M7.6153 16.4747H1.02539C0.459101 16.4747 0 16.9338 0 17.5001C0 18.0664 0.459101 18.5255 1.02539 18.5255H7.6153C8.18159 18.5255 8.64069 18.0664 8.64069 17.5001C8.64069 16.9338 8.18159 16.4747 7.6153 16.4747Z" />
        <path d="M9.45231 11.6697L3.74526 8.37468C3.25471 8.0914 2.62772 8.25949 2.34458 8.74997C2.06143 9.24038 2.22946 9.86751 2.71987 10.1507L8.42692 13.4457C8.58838 13.539 8.76468 13.5833 8.93865 13.5833C9.29303 13.5833 9.6377 13.3994 9.8276 13.0704C10.1107 12.5799 9.94272 11.9528 9.45231 11.6697Z" />
        <path d="M13.4467 8.42677L10.1518 2.71979C9.86866 2.22931 9.24153 2.06129 8.75112 2.3445C8.26071 2.62764 8.09268 3.25477 8.37583 3.74518L11.6707 9.45216C11.8606 9.78118 12.2053 9.96499 12.5597 9.96499C12.7337 9.96499 12.91 9.9207 13.0714 9.82745C13.5618 9.54431 13.7299 8.91718 13.4467 8.42677Z" />
      </>
    ),
  },
  loadingOutlined: {
    fill,
    viewBox: "0 0 1024 1024",
    className: "loadingCircle",
    icon: (
      <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
    ),
  },
  "new-tab": {
    fill,
    viewBox: "-1 1 14 14",
    icon: (
      <g fillRule="evenodd" clipRule="evenodd">
        <path d="M0.5 2.50012H4.5V3.54305H1.5098V12.255H10.2375V9.00012H11.281V13.3049H0.5V2.50012Z" />
        <path d="M11.1954 6.50616C11.2111 6.78259 11.0002 7.00484 10.7242 7.00257C10.4482 7.00031 10.266 6.78259 10.2503 6.50616L10.2503 4.11691C10.23 3.761 9.90697 3.51968 9.55105 3.49942L6.97721 3.49947C6.70079 3.48373 6.47236 3.29003 6.47261 2.97126C6.47286 2.6525 6.69259 2.48431 6.96902 2.50004L10.5237 2.50001C10.8796 2.52027 11.1752 2.81584 11.1954 3.17176L11.1954 6.50616Z" />
        <path d="M5.02331 8.72644C4.82158 8.52471 4.81126 8.20796 5.00026 8.01896L9.58144 3.39345C9.77044 3.20445 10.1147 3.16052 10.3164 3.36225C10.5181 3.56398 10.5284 3.88073 10.3394 4.06972L5.73079 8.74949C5.54179 8.93849 5.22504 8.92817 5.02331 8.72644Z" />
      </g>
    ),
  },
  ordered: {
    fill,
    viewBox: "0 0 14 17",
    icon: (
      <>
        <path fillRule="evenodd" clipRule="evenodd" d="M14 4H5V2H14V4Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M14 16H5V14H14V16Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M14 10H5V8H14V10Z" />
        <path d="M2.66667 5H1.32139V1.30495L0 1.63805V0.758929L2.54328 0H2.66667V5Z" />
        <path d="M4 11H0.114723V10.2552L1.9044 8.58971C2.34544 8.14511 2.56597 7.79192 2.56597 7.53013C2.56597 7.31799 2.5137 7.15662 2.40918 7.04604C2.30465 6.93545 2.15296 6.88016 1.95411 6.88016C1.75781 6.88016 1.59847 6.95464 1.4761 7.10359C1.35373 7.25028 1.29254 7.43421 1.29254 7.65538H0C0 7.35297 0.0854047 7.07425 0.256214 6.81923C0.427024 6.56195 0.664117 6.36109 0.967495 6.21666C1.27087 6.07222 1.60994 6 1.9847 6C2.58636 6 3.04908 6.123 3.37285 6.36899C3.69917 6.61499 3.86233 6.96818 3.86233 7.42857C3.86233 7.62266 3.82154 7.81223 3.73996 7.99729C3.65838 8.18009 3.53091 8.37305 3.35755 8.57617C3.18674 8.77703 2.91013 9.04672 2.52772 9.38524L1.8088 10.1198H4V11Z" />
        <path d="M1.32325 14.0307H1.92439C2.40076 14.0307 2.63894 13.8248 2.63894 13.4128C2.63894 13.2525 2.58223 13.1222 2.46881 13.022C2.35539 12.9196 2.19534 12.8684 1.98866 12.8684C1.81979 12.8684 1.67234 12.9118 1.54631 12.9987C1.42281 13.0855 1.36106 13.1935 1.36106 13.3226H0.0869565C0.0869565 13.0666 0.167612 12.8383 0.328923 12.6379C0.490233 12.4375 0.713296 12.2817 0.99811 12.1703C1.28544 12.0568 1.6005 12 1.94329 12C2.55577 12 3.03718 12.1236 3.38752 12.3707C3.73787 12.6179 3.91304 12.9575 3.91304 13.3894C3.91304 13.5988 3.83995 13.7969 3.69376 13.984C3.55009 14.1688 3.33963 14.3191 3.06238 14.4349C3.35476 14.5284 3.58412 14.6709 3.75047 14.8624C3.91682 15.0517 4 15.2866 4 15.5671C4 16.0013 3.81096 16.3487 3.43289 16.6092C3.05482 16.8697 2.55829 17 1.94329 17C1.58286 17 1.24764 16.9399 0.937618 16.8196C0.63012 16.6972 0.396975 16.5291 0.238185 16.3153C0.0793951 16.0993 0 15.8544 0 15.5805H1.28166C1.28166 15.7297 1.34972 15.8588 1.48582 15.9679C1.62193 16.077 1.78954 16.1316 1.98866 16.1316C2.21298 16.1316 2.39193 16.077 2.52552 15.9679C2.65911 15.8566 2.7259 15.7152 2.7259 15.5438C2.7259 15.2988 2.65658 15.1251 2.51796 15.0227C2.37933 14.9203 2.18778 14.8691 1.94329 14.8691H1.32325V14.0307Z" />
      </>
    ),
  },
  play: {
    fill,
    viewBox: "0 0 23 31",
    icon: <path d="M0 31V2.79279V0L23 15.5L0 31Z" />,
  },
  circlePlay: {
    fill,
    viewBox: "0 0 49 49",
    icon: (
      <path
        d="M24.4999 0C10.969 0 0 10.969 0 24.4999C0 38.0309 10.969 48.9999 24.4999 48.9999C38.0309 48.9999 48.9999 38.0309 48.9999 24.4999C48.9855 10.9751 38.0249 0.014458 24.4999 0ZM34.8178 25.2806C34.6482 25.6208 34.3725 25.8966 34.0322 26.0662V26.0749L20.0322 33.075C19.1676 33.507 18.1166 33.1564 17.6845 32.2918C17.5616 32.046 17.4984 31.7747 17.4999 31.5V17.5C17.4995 16.5335 18.2826 15.7497 19.2491 15.7492C19.521 15.7491 19.7891 15.8122 20.0322 15.9337L34.0322 22.9338C34.8972 23.3648 35.249 24.4156 34.8178 25.2806Z"
        fill="currentColor"
      />
    ),
  },
  plus: {
    stroke,
    viewBox: "0 0 9 9",
    icon: (
      <path
        strokeWidth="1.4"
        d="M0.513424 3.99999L4.5 4.00006V0.00633407M8.51342 4.01268L4.52685 4.01261V8.00634"
      />
    ),
  },
  pencil: {
    fill,
    viewBox: "0 0 37 35",
    icon: (
      <>
        <g stroke="currentColor" strokeWidth="0.3">
          <path d="M20.0152 12.5151L9.80469 22.7256L11.2896 24.2105L21.5001 14L20.0152 12.5151Z" />
          <path d="M28.8657 14.5516L28.8657 14.5515L28.861 14.5515C28.7081 14.5524 28.5566 14.5231 28.415 14.4653C28.2736 14.4076 28.145 14.3225 28.0365 14.2149C28.0365 14.2149 28.0364 14.2148 28.0363 14.2147L19.8923 6.04452L19.8922 6.04435C19.7838 5.93599 19.6979 5.80735 19.6392 5.66578C19.5806 5.52421 19.5504 5.37247 19.5504 5.21923C19.5504 5.06599 19.5806 4.91426 19.6392 4.77268C19.6979 4.63111 19.7838 4.50247 19.8922 4.39412C20.0005 4.28576 20.1292 4.19981 20.2707 4.14117C20.4123 4.08253 20.564 4.05234 20.7173 4.05234C20.8705 4.05234 21.0223 4.08253 21.1638 4.14117C21.3054 4.19981 21.434 4.28576 21.5424 4.39412L29.7132 12.5649L29.7136 12.5653C29.8225 12.6733 29.9089 12.8018 29.9679 12.9433C30.0268 13.0849 30.0572 13.2367 30.0572 13.39C30.0572 13.5433 30.0268 13.6952 29.9679 13.8367C29.9089 13.9783 29.8225 14.1067 29.7136 14.2147L29.7136 14.2147C29.6023 14.3252 29.4698 14.412 29.3241 14.4699C29.1783 14.5278 29.0224 14.5556 28.8657 14.5516Z" />
          <path d="M3.44512 24.1281L3.48235 24.0909L24.5977 2.97556C24.7578 2.81486 24.9481 2.68735 25.1577 2.60034C25.3672 2.51334 25.5918 2.46855 25.8187 2.46855C26.0456 2.46855 26.2702 2.51334 26.4798 2.60034C26.6893 2.68735 26.8796 2.81486 27.0398 2.97556L31.1313 7.06714L3.44512 24.1281ZM3.44512 24.1281L3.43933 24.1804M3.44512 24.1281L3.43933 24.1804M3.43933 24.1804L2.65241 31.2889L2.6318 31.4751M3.43933 24.1804L2.6318 31.4751M2.6318 31.4751L2.81801 31.4545M2.6318 31.4751L2.81801 31.4545M2.81801 31.4545L9.92646 30.6676L9.97879 30.6618M2.81801 31.4545L9.97879 30.6618M9.97879 30.6618L10.016 30.6246M9.97879 30.6618L10.016 30.6246M10.016 30.6246L31.1313 9.50923M10.016 30.6246L31.1313 9.50923M31.1313 9.50923C31.1314 9.50917 31.1315 9.50911 31.1315 9.50905L31.1313 9.50923ZM0.157051 32.6597L0.157062 32.6595L1.16672 23.4807C1.16676 23.4804 1.16679 23.4801 1.16683 23.4798C1.19883 23.2203 1.31747 22.9792 1.50356 22.7954L1.50424 22.7948L22.9607 1.33827L22.9608 1.33816C23.3367 0.961517 23.7832 0.662703 24.2747 0.458823C24.7663 0.254944 25.2931 0.15 25.8253 0.15C26.3574 0.15 26.8843 0.254944 27.3758 0.458823C27.8673 0.662704 28.3138 0.961517 28.6897 1.33816L28.6898 1.33827L32.7686 5.4171L32.7687 5.41721C33.1454 5.7931 33.4442 6.23958 33.6481 6.73109C33.852 7.22261 33.9569 7.74951 33.9569 8.28163C33.9569 8.81375 33.852 9.34065 33.6481 9.83217C33.4442 10.3237 33.1454 10.7702 32.7687 11.1461L32.7686 11.1462L11.3252 32.5895L11.3246 32.5902C11.1408 32.7763 10.8997 32.895 10.6402 32.927C10.6399 32.927 10.6396 32.927 10.6393 32.9271L1.46441 33.9363L1.46047 33.9367L1.31296 33.949C1.15096 33.9492 0.990695 33.9155 0.842458 33.85C0.692509 33.7838 0.558266 33.6867 0.448556 33.5649C0.338846 33.4431 0.256153 33.2995 0.205911 33.1435C0.15567 32.9875 0.139018 32.8226 0.157051 32.6597Z" />
        </g>
        <g>
          <path d="M17 32.5C17 33.3284 16.3284 34 15.5 34C14.6716 34 14 33.3284 14 32.5C14 31.6716 14.6716 31 15.5 31C16.3284 31 17 31.6716 17 32.5Z" />
          <path d="M27 32.5C27 33.3284 26.3284 34 25.5 34C24.6716 34 24 33.3284 24 32.5C24 31.6716 24.6716 31 25.5 31C26.3284 31 27 31.6716 27 32.5Z" />
          <path d="M22 32.5C22 33.3284 21.3284 34 20.5 34C19.6716 34 19 33.3284 19 32.5C19 31.6716 19.6716 31 20.5 31C21.3284 31 22 31.6716 22 32.5Z" />
          <path d="M32 32.5C32 33.3284 31.3284 34 30.5 34C29.6716 34 29 33.3284 29 32.5C29 31.6716 29.6716 31 30.5 31C31.3284 31 32 31.6716 32 32.5Z" />
          <path d="M37 32.5C37 33.3284 36.3284 34 35.5 34C34.6716 34 34 33.3284 34 32.5C34 31.6716 34.6716 31 35.5 31C36.3284 31 37 31.6716 37 32.5Z" />
        </g>
      </>
    ),
  },
  "plus-camera": {
    fill,
    viewBox: "0 0 36 28",
    icon: (
      <>
        <path d="M18 22C21.866 22 25 18.866 25 15C25 11.134 21.866 8 18 8C14.134 8 11 11.134 11 15C11 18.866 14.134 22 18 22Z" />
        <path d="M6.4 7C6.4 7 5.7392 7 5.6 7C4.7168 7 4 7.672 4 8.5C4 9.328 4.7168 10 5.6 10C5.7392 10 6.2608 10 6.4 10C7.2832 10 8 9.328 8 8.5C8 7.672 7.2832 7 6.4 7Z" />
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeMiterlimit="10"
          strokeLinecap="round"
          d="M33.5833 3.97143H26.5C25.4595 3.97143 24.7405 1 23.6667 1H12.3333C11.2595 1 10.5405 3.97143 9.5 3.97143H2.41667C1.63467 3.97143 1 4.63703 1 5.45714V25.5143C1 26.3344 1.63467 27 2.41667 27H33.5833C34.3653 27 35 26.3344 35 25.5143V5.45714C35 4.63703 34.3653 3.97143 33.5833 3.97143Z"
        />
        <path
          fill="white"
          stroke="white"
          strokeWidth="0.3"
          d="M17.3835 11.4667V14.3833L14.4667 14.3833C14.1261 14.3833 13.85 14.6594 13.85 15C13.85 15.3406 14.1261 15.6167 14.4667 15.6167H17.3835V18.5333C17.3835 18.8739 17.6596 19.15 18.0001 19.15C18.3407 19.15 18.6168 18.8739 18.6168 18.5333V15.6167H21.5333C21.8739 15.6167 22.15 15.3406 22.15 15C22.15 14.6594 21.8739 14.3833 21.5333 14.3833L18.6168 14.3833V11.4667C18.6168 11.1261 18.3407 10.85 18.0001 10.85C17.6596 10.85 17.3835 11.1261 17.3835 11.4667Z"
        />
      </>
    ),
  },
  "plus-circle": {
    stroke,
    viewBox: "0 0 14 14",
    icon: (
      <g strokeWidth="1.3">
        <circle cx="7" cy="7" r="6.35" />
        <path d="M6.99882 3.75L6.99902 7M6.99882 10.25L6.99902 7M6.99902 7H3.78916H10.3286" />
      </g>
    ),
  },
  redo: {
    stroke,
    viewBox: "0 0 15 14",
    icon: (
      <>
        <path
          strokeWidth="1.2"
          d="M5.25806 13C5.25806 13 1 13 1 9C1 5 5.25806 5 5.25806 5C5.25806 5 5.25806 5 5.25806 5H12.5"
        />
        <path
          fill="currentcolor"
          strokeWidth="0.2"
          d="M9.07503 1.8184L9.07502 1.81841L9.07379 1.8173C8.83333 1.59983 8.84424 1.24975 9.09506 1.04401C9.33695 0.845592 9.71531 0.852843 9.94698 1.06185L13.8782 4.5205L13.8782 4.52049L13.8792 4.52141C14.1736 4.78759 14.1736 5.21241 13.8793 5.47859L13.8793 5.4786L13.8782 5.4795L9.94697 8.93815C9.7153 9.14716 9.33695 9.15441 9.09506 8.95599C8.84424 8.75025 8.83333 8.40017 9.07379 8.1827L9.07378 8.18269L9.07503 8.1816L12.3353 5.32972C12.5411 5.14311 12.5411 4.85688 12.3353 4.67027L9.07503 1.8184Z"
        />
      </>
    ),
  },
  right: {
    fill,
    viewBox: "0 0 10 18",
    icon: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.4569 17.1313C2.01532 17.6073 1.26811 17.6256 0.803852 17.1716C0.356522 16.7342 0.339109 16.0201 0.764591 15.5614L5.58958 10.3602C6.30124 9.59302 6.30124 8.40698 5.58958 7.63982L0.764592 2.43857C0.339109 1.9799 0.356521 1.26576 0.803851 0.828375C1.26811 0.374439 2.01532 0.392656 2.4569 0.868679L8.73821 7.63982C9.44987 8.40697 9.44987 9.59303 8.73821 10.3602L2.4569 17.1313Z"
      />
    ),
  },
  search: {
    stroke,
    viewBox: "0 0 14 14",
    icon: (
      <path d="M8.97265 9.05875C9.84782 8.20585 10.3913 7.01422 10.3913 5.69565C10.3913 3.10231 8.28899 1 5.69565 1C3.10231 1 1 3.10231 1 5.69565C1 8.28899 3.10231 10.3913 5.69565 10.3913C6.97042 10.3913 8.12655 9.88333 8.97265 9.05875ZM8.97265 9.05875L13 13" />
    ),
  },
  telegram: {
    fill,
    viewBox: "0 0 23 20",
    icon: (
      <path d="M0.406248 9.58993L5.70592 11.5654L7.75721 18.154C7.88846 18.576 8.40512 18.732 8.74805 18.4519L11.7022 16.0467C12.0118 15.7947 12.4529 15.7822 12.7765 16.0168L18.1047 19.8803C18.4715 20.1466 18.9913 19.9458 19.0833 19.5031L22.9865 0.751873C23.0869 0.268259 22.6111 -0.135187 22.15 0.0429145L0.400038 8.42278C-0.136706 8.62951 -0.132029 9.38847 0.406248 9.58993ZM7.42662 10.5138L17.7842 4.14268C17.9703 4.02852 18.1618 4.2799 18.002 4.42798L9.5037 12.6022C9.20324 12.8815 9.00943 13.2553 8.95453 13.661L8.66335 15.8162C8.62479 16.1039 8.22006 16.1325 8.14056 15.854L6.97099 11.6856C6.84273 11.2373 7.02964 10.7585 7.42662 10.5138Z" />
    ),
  },
  "text-color": {
    fill,
    viewBox: "0 0 22 16",
    icon: (
      <>
        <path d="M1.78727 12H0L4.28945 0H5.71055L10 12H8.21273L7.22755 9.23721H2.76373L1.78727 12ZM6.60854 7.52558L4.99564 2.76279L3.39146 7.52558H6.60854Z" />
        <path
          opacity="0.3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 16H0V14H10V16Z"
        />
        <path
          stroke="currentColor"
          strokeWidth="0.2"
          d="M13.8184 5.07503L13.8184 5.07502L13.8173 5.07379C13.5998 4.83333 13.2498 4.84424 13.044 5.09506C12.8456 5.33695 12.8528 5.71529 13.0618 5.94696L16.5205 9.87823L16.5205 9.87823L16.5214 9.87925C16.7876 10.1736 17.2124 10.1736 17.4786 9.87925L17.4786 9.87926L17.4795 9.87823L20.9382 5.94697C21.1472 5.71529 21.1544 5.33695 20.956 5.09506C20.7502 4.84424 20.4002 4.83333 20.1827 5.07379L20.1827 5.07378L20.1816 5.07503L17.3297 8.33533C17.1431 8.54108 16.8569 8.54108 16.6703 8.33534L13.8184 5.07503Z"
        />
      </>
    ),
  },
  trash: {
    fill,
    viewBox: "0 0 12 15",
    icon: (
      <>
        <path d="M10.8462 2.57302H8.30769V1.77789C8.30769 1.07327 7.68655 0.5 6.92308 0.5H5.07692C4.31345 0.5 3.69231 1.07327 3.69231 1.77789V2.57302H1.15385C0.517615 2.57302 0 3.05074 0 3.63793V5.1288C0 5.36404 0.206654 5.55477 0.461538 5.55477H0.713769L1.11251 13.2829C1.14773 13.9654 1.75523 14.5 2.49554 14.5H9.50446C10.2448 14.5 10.8523 13.9654 10.8875 13.2829L11.2862 5.55477H11.5385C11.7933 5.55477 12 5.36404 12 5.1288V3.63793C12 3.05074 11.4824 2.57302 10.8462 2.57302ZM4.61538 1.77789C4.61538 1.54302 4.82244 1.35193 5.07692 1.35193H6.92308C7.17756 1.35193 7.38462 1.54302 7.38462 1.77789V2.57302H4.61538V1.77789ZM0.923077 3.63793C0.923077 3.5205 1.02661 3.42495 1.15385 3.42495H10.8462C10.9734 3.42495 11.0769 3.5205 11.0769 3.63793V4.70284C10.9347 4.70284 1.51249 4.70284 0.923077 4.70284V3.63793ZM9.96545 13.2424C9.95371 13.4699 9.75121 13.6481 9.50446 13.6481H2.49554C2.24876 13.6481 2.04626 13.4699 2.03455 13.2424L1.63788 5.55477H10.3621L9.96545 13.2424Z" />
        <path d="M7.38291 11.7C7.63779 11.7 7.84444 11.5093 7.84444 11.274V7.79345C7.84444 7.55821 7.63779 7.36748 7.38291 7.36748C7.12802 7.36748 6.92137 7.55821 6.92137 7.79345V11.274C6.92137 11.5093 7.12799 11.7 7.38291 11.7Z" />
        <path d="M4.46154 11.7C4.71642 11.7 4.92308 11.5093 4.92308 11.274V7.79345C4.92308 7.55821 4.71642 7.36748 4.46154 7.36748C4.20665 7.36748 4 7.55821 4 7.79345V11.274C4 11.5093 4.20663 11.7 4.46154 11.7Z" />
      </>
    ),
  },
  underline: {
    fill,
    viewBox: "0 0 9 14",
    icon: (
      <>
        <path d="M4.99609 9.39844C5.39323 9.39844 5.76107 9.32682 6.09961 9.18359C6.44466 9.03385 6.74414 8.82878 6.99805 8.56836C7.25195 8.30794 7.44727 7.99544 7.58398 7.63086C7.72721 7.26628 7.79883 6.85612 7.79883 6.40039V0.402344H9.70312V6.40039C9.70312 7.07747 9.58594 7.70573 9.35156 8.28516C9.11719 8.85807 8.78841 9.35612 8.36523 9.7793C7.94857 10.196 7.45378 10.5215 6.88086 10.7559C6.30794 10.9837 5.67969 11.0977 4.99609 11.0977C4.31901 11.0977 3.69401 10.9837 3.12109 10.7559C2.54818 10.5215 2.05013 10.196 1.62695 9.7793C1.21029 9.35612 0.884766 8.85807 0.650391 8.28516C0.416016 7.70573 0.298828 7.07747 0.298828 6.40039V0.402344H2.20312V6.40039C2.20312 6.85612 2.27148 7.26628 2.4082 7.63086C2.55143 7.99544 2.75 8.30794 3.00391 8.56836C3.25781 8.82878 3.55404 9.03385 3.89258 9.18359C4.23112 9.32682 4.59896 9.39844 4.99609 9.39844Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.5 14.5H0.5V12.5H9.5V14.5Z"
        />
      </>
    ),
  },
  undo: {
    stroke,
    viewBox: "0 0 15 14",
    icon: (
      <>
        <path
          strokeWidth="1.2"
          d="M9.74194 13C9.74194 13 14 13 14 9C14 5 9.74194 5 9.74194 5C9.74194 5 9.74194 5 9.74194 5H2.5"
        />
        <path
          fill="currentColor"
          strokeWidth="0.2"
          d="M5.92497 1.8184L5.92498 1.81841L5.92621 1.8173C6.16667 1.59983 6.15576 1.24975 5.90494 1.04401C5.66305 0.845596 5.28471 0.852842 5.05304 1.06184L1.12177 4.5205L1.12177 4.52049L1.12075 4.52141C0.826419 4.78759 0.826416 5.21241 1.12075 5.47859L1.12074 5.4786L1.12177 5.4795L5.05303 8.93815C5.28471 9.14716 5.66305 9.15441 5.90494 8.95599C6.15576 8.75025 6.16667 8.40017 5.92621 8.1827L5.92622 8.18269L5.92497 8.1816L2.66467 5.32972C2.45892 5.14311 2.45892 4.85689 2.66466 4.67028L5.92497 1.8184Z"
        />
      </>
    ),
  },
  unordered: {
    fill,
    viewBox: "0 0 14 16",
    icon: (
      <>
        <path fillRule="evenodd" clipRule="evenodd" d="M14 3H5V1H14V3Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M14 15H5V13H14V15Z" />
        <path fillRule="evenodd" clipRule="evenodd" d="M14 9H5V7H14V9Z" />
        <path d="M3.5 2C3.5 2.82843 2.82843 3.5 2 3.5C1.17157 3.5 0.5 2.82843 0.5 2C0.5 1.17157 1.17157 0.5 2 0.5C2.82843 0.5 3.5 1.17157 3.5 2Z" />
        <path d="M3.5 8C3.5 8.82843 2.82843 9.5 2 9.5C1.17157 9.5 0.5 8.82843 0.5 8C0.5 7.17157 1.17157 6.5 2 6.5C2.82843 6.5 3.5 7.17157 3.5 8Z" />
        <path d="M3.5 14C3.5 14.8284 2.82843 15.5 2 15.5C1.17157 15.5 0.5 14.8284 0.5 14C0.5 13.1716 1.17157 12.5 2 12.5C2.82843 12.5 3.5 13.1716 3.5 14Z" />
      </>
    ),
  },
  user: {
    fill,
    viewBox: "0 0 12 14",
    icon: (
      <>
        <path d="M6.00025 0.644531C4.18063 0.644531 2.70025 2.18221 2.70025 4.07227C2.70025 5.96232 4.18063 7.5 6.00025 7.5C7.81987 7.5 9.30025 5.96232 9.30025 4.07227C9.30025 2.18221 7.81987 0.644531 6.00025 0.644531Z" />
        <path d="M10.473 10.0948C9.56949 9.14194 7.27158 8.61719 6.00025 8.61719C4.72894 8.61719 2.29808 9.14194 1.39461 10.0948C0.49557 11.043 0.5 12.6754 0.5 14H11.3669C11.3669 12.6754 11.372 11.043 10.473 10.0948Z" />
      </>
    ),
  },
  video: {
    fill,
    viewBox: "64 64 896 896",
    icon: (
      <path d="M960 509.2c0-2.2 0-4.7-.1-7.6-.1-8.1-.3-17.2-.5-26.9-.8-27.9-2.2-55.7-4.4-81.9-3-36.1-7.4-66.2-13.4-88.8a139.52 139.52 0 00-98.3-98.5c-28.3-7.6-83.7-12.3-161.7-15.2-37.1-1.4-76.8-2.3-116.5-2.8-13.9-.2-26.8-.3-38.4-.4h-29.4c-11.6.1-24.5.2-38.4.4-39.7.5-79.4 1.4-116.5 2.8-78 3-133.5 7.7-161.7 15.2A139.35 139.35 0 0082.4 304C76.3 326.6 72 356.7 69 392.8c-2.2 26.2-3.6 54-4.4 81.9-.3 9.7-.4 18.8-.5 26.9 0 2.9-.1 5.4-.1 7.6v5.6c0 2.2 0 4.7.1 7.6.1 8.1.3 17.2.5 26.9.8 27.9 2.2 55.7 4.4 81.9 3 36.1 7.4 66.2 13.4 88.8 12.8 47.9 50.4 85.7 98.3 98.5 28.2 7.6 83.7 12.3 161.7 15.2 37.1 1.4 76.8 2.3 116.5 2.8 13.9.2 26.8.3 38.4.4h29.4c11.6-.1 24.5-.2 38.4-.4 39.7-.5 79.4-1.4 116.5-2.8 78-3 133.5-7.7 161.7-15.2 47.9-12.8 85.5-50.5 98.3-98.5 6.1-22.6 10.4-52.7 13.4-88.8 2.2-26.2 3.6-54 4.4-81.9.3-9.7.4-18.8.5-26.9 0-2.9.1-5.4.1-7.6v-5.6zm-72 5.2c0 2.1 0 4.4-.1 7.1-.1 7.8-.3 16.4-.5 25.7-.7 26.6-2.1 53.2-4.2 77.9-2.7 32.2-6.5 58.6-11.2 76.3-6.2 23.1-24.4 41.4-47.4 47.5-21 5.6-73.9 10.1-145.8 12.8-36.4 1.4-75.6 2.3-114.7 2.8-13.7.2-26.4.3-37.8.3h-28.6l-37.8-.3c-39.1-.5-78.2-1.4-114.7-2.8-71.9-2.8-124.9-7.2-145.8-12.8-23-6.2-41.2-24.4-47.4-47.5-4.7-17.7-8.5-44.1-11.2-76.3-2.1-24.7-3.4-51.3-4.2-77.9-.3-9.3-.4-18-.5-25.7 0-2.7-.1-5.1-.1-7.1v-4.8c0-2.1 0-4.4.1-7.1.1-7.8.3-16.4.5-25.7.7-26.6 2.1-53.2 4.2-77.9 2.7-32.2 6.5-58.6 11.2-76.3 6.2-23.1 24.4-41.4 47.4-47.5 21-5.6 73.9-10.1 145.8-12.8 36.4-1.4 75.6-2.3 114.7-2.8 13.7-.2 26.4-.3 37.8-.3h28.6l37.8.3c39.1.5 78.2 1.4 114.7 2.8 71.9 2.8 124.9 7.2 145.8 12.8 23 6.2 41.2 24.4 47.4 47.5 4.7 17.7 8.5 44.1 11.2 76.3 2.1 24.7 3.4 51.3 4.2 77.9.3 9.3.4 18 .5 25.7 0 2.7.1 5.1.1 7.1v4.8zM423 646l232-135-232-133z" />
    ),
  },
  exit: {
    fill,
    viewBox: "0 0 12 12",
    icon: (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.5 0.5H11V1.54293H1.5098V10.2549H10.2375H11V11.3048H0.5V0.5Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M 9.123 8.87 C 8.939 9.077 8.632 9.085 8.439 8.888 C 8.245 8.691 8.27 8.409 8.455 8.202 L 10.144 6.513 C 10.382 6.247 10.324 5.847 10.086 5.581 L 8.266 3.762 C 8.082 3.555 8.058 3.256 8.283 3.031 C 8.509 2.806 8.783 2.842 8.967 3.049 L 11.481 5.563 C 11.718 5.829 11.718 6.247 11.481 6.513 L 9.123 8.87 Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M 3.189 6.076 C 3.189 5.791 3.405 5.559 3.673 5.559 L 10.183 5.528 C 10.45 5.528 10.725 5.74 10.725 6.026 C 10.725 6.311 10.508 6.542 10.241 6.542 L 3.673 6.592 C 3.405 6.592 3.189 6.361 3.189 6.076 Z"
          fill="currentColor"
        />
      </>
    ),
  },
};

export default function SvgIcon(props) {
  const { type, className, style } = props;

  const iconItem = iconListData[type] || {};

  return (
    <svg
      viewBox={iconItem?.viewBox}
      className={
        "svg-icon" +
        (className ? " " + className : "") +
        (iconItem?.fill ? " fill-icon" : "") +
        (iconItem?.stroke ? " stroke-icon" : "") +
        (iconItem.className ? " " + iconItem.className : "")
      }
      style={style}
    >
      {iconItem?.icon}
    </svg>
  );
}
